import { createTrackStandaloneEventHook } from './useTrackStandaloneEvent';
export const useTrackInstallButtonClicked = createTrackStandaloneEventHook('Install Button Clicked');